import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import withAttr from 'flarum/common/utils/withAttr';

function onClick(event, callback) {
    if (event.pointerType != 'mouse' || event.button == 0) {
        event.preventDefault();
        callback(event);
    }
}

function getPrecision(value) {
    if (!isFinite(value)) return 0;
    let exp = 1, precision = 0;
    while (Math.round(value * exp) / exp !== value) { exp *= 10; precision++; }
    return precision;
}

export default class Slider extends Component {
    oninit(vnode) {
        super.oninit(vnode);

        this.timeout = null;
        this.interval = null;
        this.tick = 50;
        this.delay = 300;

        this.min = Number(this.attrs.min) || 0.00;
        this.max = Number(this.attrs.max) || 100.00;
        this.value = Number(this.attrs.value) || 0.00;
        this.step = Number(this.attrs.step) || 0.01;
        this.precision = getPrecision(this.step);

        // big step is calculated as value that accumulate value between min and max within 1000 milliseconds powered by step
        this.big_step = this.step * Math.max(1.00, (this.tick * (this.max - this.min)) / 1000);
    }

    view() {
        return (
            <div className="Slider">
                <Button
                    className='Button Button--icon'
                    icon='fas fa-minus'
                    aria-label='minus'
                    onpointerdown={(e) => onClick(e, () => this.timeout = setTimeout(() => this.interval = setInterval(this.decrement.bind(this, this.big_step), this.tick), this.delay)) }
                    onpointerup={(e) => onClick(e, () => clearInterval(this.interval) || clearTimeout(this.timeout) || this.decrement(this.step) || this.onchange(this.value)) }
                />
                <input
                    type='number'
                    aria-label='number'
                    step={this.step}
                    min={this.min}
                    max={this.max}
                    value={this.fixed_value()}
                    onchange={withAttr('value', this.onchange.bind(this))}
                    required
                >
                </input>
                <Button
                    className='Button Button--icon'
                    icon='fas fa-plus'
                    aria-label='plus'
                    onpointerdown={(e) => onClick(e, () => this.timeout = setTimeout(() => this.interval = setInterval(this.increment.bind(this, this.big_step), this.tick), this.delay)) }
                    onpointerup={(e) => onClick(e, () => clearInterval(this.interval) || clearTimeout(this.timeout) || this.increment(this.step) || this.onchange(this.value)) }
                />
            </div>
        )
    }

    decrement(step) {
        this.value = Math.max(this.value - step, this.min);
        m.redraw();
    }

    increment(step) {
        this.value = Math.min(this.value + step, this.max);
        m.redraw();
    }

    onchange(value) {
        this.value = Math.max(Math.min(value, this.max), this.min)
        if (this.attrs.onchange) this.attrs.onchange(this.fixed_value(), this);
    }

    fixed_value() {
        return Number(this.value).toFixed(this.precision);
    }
}
